<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<lms-message [target]="'page'"></lms-message>
<lms-dialog-operation></lms-dialog-operation>
<lms-side-navigation *ngIf="currentUrl !== '/500' && showHeader" class="side-nagivation-wrapper" [currentUrl]="currentUrl" [editMode]="editMode?.status"></lms-side-navigation>
<div id="pageDetails" class="page-details-wrapper {{(selectedTab?.type === 'Terminal' && selectedTab?.subType === 'Status') ? 'terminal-status-wrapper' : ''}} {{(!showHeader && selectedTab?.type === 'Terminal')  ? 'page-content-no-header' : ''}} {{(!showHeader)  ? 'page-content-whole-page' : ''}}">
    <div class="outlying-points">
        <!--{{enableTabsStatus}}-->
        <lms-tabs *ngIf="(selectedTab?.type !== 'Locomotive-Status' && selectedTab?.type !== 'Yard-Local' && selectedTab?.type !== 'Query-View' && this.selectedMenu && this.selectedMenu.tabSupported)" #lmsTabs [tabs]="filteredTabs" (lmsTabChange)="lmsEventHandler($event)"
            [editMode]="editMode?.status"></lms-tabs>

        <router-outlet>
            <!-- router template will load here -->
        </router-outlet>

    </div>
    <div class="clear"></div>
</div>
<!-- unsaved changed state popup (',') -Start- (',')  -->

<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="routeNavigationWarnDialog" [resizable]="false" [draggable]="false" class="terminal-ui-popups standard-dialog editModeWarnPop" header="Confirmation" [(visible)]="routePopupData.status" modal="true" (onHide)='hideRoutePopup();setPageMode(null);'
    (onShow)='setPageMode({mode: "Edit", id: "editModeNavHideBtn"}); setFocus("routeNavigationWarnDialog");'>
    <div class="generic-spacing editModeWarnContent">
        <p>You have unsaved changes on <b>{{currentScreen}}</b>:</p><br>
        <p class="previous-screen">Return to <button class="p-button-primary" tabindex="{{tabLevelDialog - 2}}" id="editModeNavHideBtn" (click)="hideRoutePopup()">{{currentScreen}}</button></p><br>
        <p class="next-screen">Do not save changes, proceed to <button class="p-button-secondary" tabindex="{{tabLevelDialog - 1}}" (click)="goToNextRoute()">{{nextScreen}}</button></p>
    </div>
</p-dialog>
<!-- unsaved changed state popup (',') -Stop- (',')  -->
